import { render, staticRenderFns } from "./BaseGoodsCard.vue?vue&type=template&id=343fb401"
import script from "./BaseGoodsCard.vue?vue&type=script&lang=js"
export * from "./BaseGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./BaseGoodsCard.vue?vue&type=style&index=0&id=343fb401&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports